import Nav from '../components/Nav';
import Footer from '../components/Footer';

import * as data from '../data';
import ProductCard  from '../components/ProductCard';
function Shop() {
    let Products = data.getProducts();
    let categories = data.getCategories();
    
    return <div class="bg-gray-100">
        <Nav />
        <div class="pt-0 p-2 lg:p-16">
            <h2 class="text-lg pt-16 text-gray-900 font-bold">Shop</h2> 
            <div class="flex ">
                <div class="hidden bg-white p-2 border-t-2 rounded-t-lg border-blue-600 lg:block w-1/5">
                    
                    <div class="">
                    <h2 class="text-gray-900 text-lg font-bold uppercase"i >categories</h2>
                    <ul class="text-gray-700">
                    { categories.map(category => (
                            <li class="p-2"><input type="checkbox" key={category.id}></input>  {category.name} ({category.count})</li>
                            
                        ))}
                        </ul>
                    </div>

                    <div class="border-t pt-2 mt-2">
                    <h2 class="text-gray-900 text-lg font-bold uppercase">Brands</h2>
                    <ul class="text-gray-700">
                    { categories.map(category => (
                            <li class="p-2"><input type="checkbox" key={category.id}></input>  {category.name} ({category.count})</li>
                            
                        ))}
                        </ul>
                    </div>

                    <div class="hidden border-t pt-2 mt-2">
                    <h2 class="text-gray-900 text-lg font-bold uppercase">Price </h2>
                     <div class="flex gap-2 mt-2 ">
                         <input type="text" placeholder="min" class="border p-2 w-1/2 rounded-lg"></input>
                         <input type="text" placeholder="max" class="border p-2 w-1/2 rounded-lg"></input>
                    </div>
                    </div>
                    <div class="border-b border-l border-b mt-6 ">
            <div class="p-2 border-t-2 rounded-t-lg border-blue-600 w-full">
              <div class="text-sm font-bold">
                  <h2 class="text-gray-700">FILTER BY  </h2>
              </div>
              <div class="border-t p-1 mt-4 ">
                    <h2 class="">PRICE</h2>
                    <div class="p-2 text-sm text-gray-800">
                        <input type="radio" name="price"></input><label> Ghc 20.00 - Ghc 80.00</label><br></br>
                        <input type="radio" name="price"></input><label> Ghc 20.00 - Ghc 80.00</label><br></br>
                        <input type="radio" name="price"></input><label> Ghc 20.00 - Ghc 80.00</label><br></br>
                        <input type="radio" name="price"></input><label> Ghc 20.00 - Ghc 80.00</label><br></br>
                    </div>
              </div>
              <div class="border-t p-1 mt-4 ">
                    <h2 class="font-bold">SIZE</h2>
                    <div class="p-2 text-sm gap-2 text-gray-800">
                    <div class="w-1/2 inline-block">
                        <input type="checkbox" name="price"></input><label> S(4)</label> <br></br>
                        <input type="checkbox" name="price"></input><label> L(3)</label>
                    </div>
                    <div class="float-right">
                       <input type="checkbox" name="price"></input><label class=""> M(2)</label> <br></br>
                        <input type="checkbox" name="price"></input><label class=""> XL(2)</label>
                       </div>
                    </div>
              </div>
              <div class="border-t p-1 mt-4 ">
                    <h2 class="font-bold">COLOR</h2>
                    <div class="p-2 text-xs text-gray-800">
                    <div class="w-1/2 inline-block">
                        <input type="checkbox" name="price"></input><label> BLACK(4)</label> <br></br>
                        <input type="checkbox" name="price"></input><label> BLACK(3)</label>
                    </div>
                    <div class="float-right">
                       <input type="checkbox" name="price"></input><label class=""> BLACK(2)</label> <br></br>
                        <input type="checkbox" name="price"></input><label class=""> BLACK(2)</label>
                       </div>
                    </div>
              </div>
              
            </div>
        </div>
                </div>
                <div class="w-full bg-white lg:w-4/5 lg:ml-12">
                        <div class="w-1/2 inline">
                            <select class="rounded-lg bg-white border p-2">
                                <option >Default Option</option>
                            </select>

                            <div class="float-right p-2  flex gap-1">
                            <div class="bg-red-600 border p-1 rounded-lg text-gray-100"> <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg></div>
                            <div class="border p-1 rounded-lg"><svg class="w-6 h-6  " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg></div>
                            </div>
                        </div>
                        <div class="mt-12 gap-2 grid grid-cols-2 lg:grid-cols-4">
                            { Products.map(products => (
                                <ProductCard name={products.name} price={products.price} cta="Add To Cart" />
                            ))}
                        
                       
                        </div>
                
                </div>
            </div>
        </div>
        <Footer />
    </div>
}

export default Shop;